module.exports = __webpack_public_path__ + "static/img/snapshot-affiche-permuteo.9bdd417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/thumb/snapshot-affiche-permuteo.png
// module id = 0oob
// module chunks = 1